import filtros from './filtros';

const state = {
  projetoSelecionado: null,
};

const mutations = {
  SET_PROJETO_SELECIONADO(state, projeto) {
    state.projetoSelecionado = projeto;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  modules: {
    filtros,
  },
};
